class Configurator
  @$inject: ["editor"]
  constructor: (@editor)->     
    @serializer = new XMLSerializer()  
  config: (device, app)->
    if device.os is "ANDROID"
      return @configAPK(device, app)
    if device.os is "LINUX"
      return @configCPK(device, app)

  configAPK: (device, app)->
    schema = {}
    source = {}
    $config = null
    device.$readPref(app.packageName).then (content)=>      
      $config = $($.parseXML(content))          
      $config.find('map > *').each (idx)->
        $this = $(this)
        field =
          name: $this.attr('name')
          type: $this.prop('tagName').toLowerCase()        
        if field.type is 'string'
          schema[field.name] = 
            type: "String"
            org: field.type
          value = $this.html()
          value = value.replace(/&amp;/g,"&").replace(/&gt;/g,">").replace(/&lt;/g,"<")
          source[field.name] = value  
        else
          schema[field.name] = 
            type: "String"
            org: field.type
          value = $this.attr('value')
          value = value.replace(/&amp;/g,"&").replace(/&gt;/g,">").replace(/&lt;/g,"<")
          source[field.name] = value                
      opts = 
        source: source
        schema: schema
      @editor.edit(opts)
    .then (result)=>
      angular.forEach result, (value, field) ->
        if schema[field].org is 'string'
          $config.find("[name=\"#{field}\"]").html(value.replace(/&/g,"&amp;").replace(/>/g,"&gt;").replace(/</g,"&lt;"))                      
        else
          $config.find("[name=\"#{field}\"]").attr('value', value.replace(/&/g,"&amp;").replace(/>/g,"&gt;").replace(/</g,"&lt;"))
      return @serializer.serializeToString($config.find('map').get(0))
    .then (config)=>
      device.$savePref(app.packageName, config)

  configCPK: (device, app)->
    device.$readPref(app.packageName).then (content)=>      
      $config = JSON.stringify(content, null ,2)
      opts = 
        source: 
          config: $config
        schema: 
          config:
            type: "Text"  
            rows: 20
      @editor.edit(opts)
    .then (result)->
      json = JSON.parse(result.config)
      device.$savePref(app.packageName, json)
      
      



    
  
module.exports = Configurator



// WEBPACK FOOTER //
// ./src/component/device/configurator/configurator.coffee